import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-email-config',
  templateUrl: './email-config.component.html',
  styleUrls: ['./email-config.component.css']
})
export class EmailConfigComponent implements OnInit {
  respConfig: any;
  configData: any;
  configVal=[];
  vall=[];
  respConfig1: any;
  configData1: any;
  configVal1=[];
  vall1=[];


  allConfigData=[];
  allConfigVal=[];
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	var cIndex = 0;
  	const data = {"configType":"EMAIL_REMINDER"}
	this._rest.getSettingsData(data).subscribe((res) => {
        this.respConfig = res;
    	if(this.respConfig.error==0){ 
    		this.configData = this.respConfig.resp;
    		
    		for(var ii=0;ii<this.configData.length;ii++){
    			var c = this.configData[ii].KeyValue;	
    			
    			var tempData = this.configData[ii];
    			tempData["index"] = cIndex;
    			this.allConfigData.push(tempData);
    			this.allConfigVal.push(c);
    			cIndex++;
    		}
    		const data1 = {"configType":"EMAIL_CONTENT"}
			this._rest.getSettingsData(data1).subscribe((res) => {
		        this.respConfig1 = res;
		    	if(this.respConfig1.error==0){ 
		    		this.configData1 = this.respConfig1.resp;
		    
		    		for(var ii=0;ii<this.configData1.length;ii++){
		    			var c = this.configData1[ii].KeyValue;	
		    			var tempData = this.configData1[ii];
		    			tempData["index"] = cIndex;
		    			this.allConfigData.push(tempData);
		    			this.allConfigVal.push(c);
		    			cIndex++;
		    		}
		    	}   
			});
    	}   
    	//console.log(res);
	});
	
	//console.log(this.allConfigData);
  }
 
  
  updateAllConfig(data){
  	var errCounter =0;
  	

  	if(errCounter==0){
  		for(var i=0;i<data.length;i++){
  			var data1 = {"keyIndex":data[i][0], "keyValue":this.allConfigVal[data[i][1]]};
	  		this._rest.updateSettingsData(data1).subscribe((res) => {
	  		});
  		}
  		alert("Email Configuration has been updated.");
  	}
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

}

